import { defineField, defineType } from 'sanity'

export default defineType({
  name: 'heroCarousel',
  title: 'Hero Carousel',
  type: 'object',
  fields: [
    defineField({
      name: 'heroList',
      title: 'Hero List',
      type: 'array',
      of: [{ type: 'hero' }],
      validation: (rule) => [rule.min(1)],
    }),
    defineField({
      name: 'duration',
      title: 'Duration',
      type: 'number',
      description:
        'Duration of each slide in milliseconds (1000 ms  = 1 second)',
      initialValue: 5000,
    }),
  ],
  preview: {
    select: {
      heroList: 'heroList',
    },
    prepare({ heroList }) {
      return {
        title: `${heroList?.length || 0} slides`,
        subtitle: `Hero Carousel`,
      }
    },
  },
})